import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5921ba7d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5921ba7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5921ba7d')) {
      api.createRecord('5921ba7d', component.options)
    } else {
      api.reload('5921ba7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5921ba7d&scoped=true", function () {
      api.rerender('5921ba7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/index.vue"
export default component.exports